import React from "react";
import "../../../css/Transparencia/informacion-publica.css";

const DeclaracionJurada = () => (
  <div className="info-publica-full-bg">
    <div className="info-publica-container">
      <h1 className="defensor-title">DECLARACIONES JURADAS</h1>
      <p className="defensor-desc">
        Un gobierno abierto y transparente que pone a disposición de los
        ciudadanos información relevante para promover mayor participación y
        cercanía.
      </p>
      <iframe
        title="Declaraciones Juradas"
        src="https://ciudaddeoliva.gov.ar/boletin-oficial/declaracion-jurada"
        width="100%"
        height="4500"
        frameBorder="0"
        allowTransparency="true"
        loading="lazy"
        style={{
          width: "100%",
          minHeight: 400,
          border: "1px solid #e0e0e0",
          borderRadius: 12,
          background: "#fff",
        }}
      ></iframe>
    </div>
  </div>
);

export default DeclaracionJurada;
